
<div class="container {{ hasLogo }}">
    <div *ngIf="hasAdminLogo" class="header-title">
        <div class="logo">
            <a href routerLink="/"><img id="logoImage" class="logoImage" [src]="logoUrl" /> </a>
        </div>
        <h2>{{headerTitle}}</h2>
        <div (click)="logOut()" *ngIf="hasAdminLogo" class="placeholder">
            <mat-icon >assignment_return</mat-icon>
            <span>Kijelentkezés</span>
        </div>
    </div>
    <div *ngIf="hasLogo" class="image header-bar-item">
        <div class="logo">
            <a href routerLink="/">
                <img *ngIf="!isRegenero" id="logoImage" class="logoImage" [src]="logoUrl" />
                <img *ngIf="isRegenero" class="img-logo" [src]="logoUrl" />
             </a>
        </div>
        <div *ngIf="hasSearchBar" class="search-bar {{ hasSearchBar }}">
            <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search"></mat-icon>
            <input type="search" placeholder="{{ 'header.searchInput' | translate }}" />
        </div>
    </div>
    <div class="facebook-icon">
        <div *ngIf="!isLoggedIn" class="login-icon">
            <mat-icon (click)="openLogin()" *ngIf="hasLogin && !hasAdmin">account_circle </mat-icon>
            <div class="show-login">
                <span (click)="openLogin()">{{showLogin}}</span><span> / </span><span (click)="openRegistration()">{{showRegistration}}</span>
            </div>
        </div>

        <div (click)="displayLoginMenu()" *ngIf="isLoggedIn" class="logged-in-menu-container">
            <mat-icon>account_circle</mat-icon>
            <span>{{personalData.lastName}} {{personalData.firstName}}</span>
            <mat-icon *ngIf="!displayLogin">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="displayLogin">keyboard_arrow_up</mat-icon>
            <div *ngIf="displayLogin" class="login-menu">
                <div class="login">
                    <div *ngIf="!hasAdmin" class="menu-item">
                        <a (click)="getPersonalData()"><span>{{'header.personalDatas' | translate}}</span></a>
                    </div>
                    <div *ngIf="!hasAdmin" class="menu-item">
                        <a (click)="getMyOrders()"><span>{{'header.myOrders' | translate}}</span></a>
                    </div>
                    <div class="menu-item">
                        <a (click)="logOut()"><span>{{'header.logOut' | translate}}</span></a>
                    </div>
                </div>
            </div>
        </div>

        <pw-shoppingcart *ngIf="hasShoppingCart"></pw-shoppingcart>
        <a *ngIf="hasFacebookIcon" href="{{ facebookURL }}" target="_blank"><img src="{{facebookImgUrl}}" /></a>
        <!-- <div
            class="fb-like"
            data-href="https://www.facebook.com/profile.php?id=100089168181347"
            data-width="64px"
            data-layout=""
            data-action=""
            data-size=""
            data-share="true"
        ></div> -->
    </div>
</div>
<div class="publisher"></div>
<div class="language-selector {{ hasLanguageSelector }}">
    <pw-languagemodule></pw-languagemodule>
</div>
<pw-navigationmodule
    [nameOfTheSite]="nameOfTheSite"
    [logoPosition]="headerConfig.PositionL"
    [hasLogo]="hasLogo"
    [isShoppingCart]="hasShoppingCart"
    [hasLogin]="hasLogin"
    [colorOfNavBar]="colorOfNavBar"
    [isAdmin]="hasAdmin"
    [navigationMenu]="navigationMenu"
    [isSubMenuFullScreen]="isSubmenuFullScreen"
    [hasMatMenu]="hasMatMenu"
    [isSideNav]="isSideNav"
    [dataManagamentUrl]="dataManagamentUrl"
    [aszfUrl]="aszfUrl"
    [isRowView]="isRowView"
    [colorOfMobileSidenav]="colorOfMobileSidenav"
    [hasMenuTitle]="hasMenuTitle"
>
</pw-navigationmodule>
